module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-final/bg.png",
      "swiper": _vm.swiper,
      "has-down-btn": true
    }
  }, [_c('div', {
    staticClass: "main-image-text-bg ani",
    staticStyle: {
      "background": "url(/static/img/anniversary/page-final/text-bg.png)",
      "background-size": "cover"
    },
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('div', {
    staticClass: "main-image-text-inner"
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n        亲爱的"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.customerName || _vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.registrationDate || _vm.customerCreateDT))]), _c('br'), _vm._v("\n        第一次与吉凯相遇"), _c('br'), _vm._v(" "), (_vm.data.campaignTimes) ? _c('p', {
    staticClass: "active-details"
  }, [_vm._v("参加过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.campaignTimes)))]), _vm._v("市场活动")]) : _vm._e(), _vm._v(" "), (_vm.data.firstContractDate) ? _c('p', {
    staticClass: "active-details"
  }, [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.firstContractDate)))]), _vm._v("签订第一个合同")]) : _vm._e(), _vm._v(" "), (_vm.data.purchaseTimes) ? _c('p', {
    staticClass: "active-details"
  }, [_vm._v("一共购买过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.purchaseTimes)))]), _vm._v("产品或服务")]) : _vm._e(), _vm._v(" "), (_vm.data.amount) ? _c('p', {
    staticClass: "active-details"
  }, [_vm._v("合同总金额"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.amount)))])]) : _vm._e()])])]), _vm._v(" "), _c('img', {
    staticClass: "pic-final ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/page-key-words-result/4.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3b41db0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageFinal/index.vue
// module id = 1705
// module chunks = 8